import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const configureAWSUser = async (payload: any) => {
    let url = `${NGROK}/api/aws/addAWSUserConfigs`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });

    return data;
};

export const fetchUserConfiguration = async (latestTenant: string, email: string) => {
    let url = `${NGROK}/api/aws/getAWSUserConfig?tenantName=${latestTenant}&tenantEmail=${email}`;
    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
};

export const fetchAWSEC2List = async (tenantName: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/getPublishedEC2Instances?tenantName=${tenantName}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
}

export const fetchAWSRDSList = async (tenantName: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/allpublishRDSInstances?tenantName=${tenantName}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
}

export const fetchAWSS3List = async (tenantName: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/getAllS3PublishBuckets?tenantName=${tenantName}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
}


export const fetchAWSClusterList = async (tenantName: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/getAllPublishedCluster?tenantName=${tenantName}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
}

export const getAWSAllPoliciesList = async (tenantName: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/getAllPublishedPolicies?tenantName=${tenantName}&accountId=${selectedAwsAccount}`;
    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
}



export const awsSubmitForm = async (payload: any) => {
    let url = `${NGROK}/api/aws-request-access`;
    const data = await apiClient({
        method: "POST",
        url: url,
        data: payload
    });

    return data;
};


export const specificAwsUser = async (tenantName: string, arn: string, selectedAwsAccount: string) => {
    let url = `${NGROK}/api/aws/getSpecificUser?policyarn=${arn}&tenantName=${tenantName}&accountId=${selectedAwsAccount}`;


    const data = await apiClient({
        method: "GET",
        url: url,
    });

    return data;
}
